import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';

import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {Column, Row} from '../../../../../components/layout';
import {DataValidationProps} from '../DataValidation';
import './styles.scss';
import Header2 from '../../../../../components/headers/header2';
import * as fonts from '../../../../../util/fonts';
import {colors} from './../../../../../util/colors';
import {useFormikContext} from 'formik';
import {Store} from '../../../../../store';

function AddContacts({
  valid,
  setValid,
  addToWizard,
  wizard,
  labels,
  messageLabels,
  nextStep,
}: DataValidationProps) {
  const validationSchema = Yup.object().shape({
    cardNumber: Yup.number().required(messageLabels?.requiredField),
  });
  const formik = useFormikContext<any>();

  const [formikContext, setFormikContext] = useState<any>();

  const userContacts =
    wizard?.dataValidation?.currentUser?.email ||
    wizard?.dataValidation?.currentUser?.phone;

  const handleNoCard = () => {
    const dataValidation = {
      currentUser: {
        ...wizard?.dataValidation?.currentUser,
        contacts: {
          ...userContacts,
          //phone: values.phone,
        },
      },
      selectedContact: '',
      selectedContactType: 'EMAIL',
      cardNumber: '',
      state: 'NOT_FOUND',
    };

    addToWizard({dataValidation});
    nextStep();
  };

  useEffect(() => {
    if (formikContext && (formikContext?.dirty as any)) {
      (formikContext as any)?.validateForm((formikContext as any)?.values);
    }
  }, [formikContext]);

  return (
    <Column className="add-contacts-container">
      <AppForm
        initialValues={{cardNumber: '', phone: ''}}
        validationSchema={validationSchema}
        onSubmit={async (values: any, {validateForm}: any) => {
          const dataValidation = {
            currentUser: {
              ...wizard?.dataValidation?.currentUser,
              contacts: {
                ...userContacts,
                //phone: values.phone,
              },
            },
            selectedContact: '',
            selectedContactType: 'EMAIL',
            cardNumber: values.cardNumber,
            state: 'NOT_FOUND',
          };

          addToWizard({dataValidation});
          nextStep();
        }}>
        <Header2 className="title-step2-responsive">
          {labels?.activationChoice_title}
        </Header2>
        <Header2 className="app-center add-contacts-header">
          {labels?.insuranceAndPhone_pageSubTitle}
        </Header2>
        <Row className="add-contacts-row">
          <AppFormField
            showErrorMessage
            name="cardNumber"
            placeholder={labels?.insuranceAndPhone_insuranceNumberPlaceholder}
            handleFormikContext={() => setFormikContext(formik)}
          />
        </Row>
        <Row className="add-contacts-row app-center">
          <Column>
            <a
              className="add-contacts-didnt-receive-question"
              onClick={handleNoCard}
              href=""
              style={{...fonts.M, color: colors.blue}}>
              {labels?.insuranceAndPhone_didndReceivedText}
            </a>
          </Column>
        </Row>

        <Row className="insurance-validation-continue-button-row">
          <AppFormSubmitButton
            title={labels?.insuranceAndPhone_confirmButtonText}
            className="stepper-continue-button"
          />
        </Row>
      </AppForm>
    </Column>
  );
}

export default AddContacts;
